import { useState } from "react";
import { IUseTanyaHowToData } from "./tanya-how-to.types";

const useTanyaHowTo: () => IUseTanyaHowToData = () => {
  const [activeScreen, setActiveScreen] = useState("1");
  const checkIsActiveScreen = (screen: string) => screen === activeScreen;
  const handleActiveScreen = (screen: string) => setActiveScreen(screen);
  return {
    activeScreen,
    checkIsActiveScreen,
    handleActiveScreen
  };
};

export { useTanyaHowTo };
